document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('.wt-product__add-to-cart_form');
    const wrapper = document.querySelector('.product-form-wrapper');
    const formThreshold = document.querySelector('.product-form-threshold');
    
    if(!form || !wrapper || !formThreshold) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // entry.boundingClientRect.top < 0 ensures this only triggers 
            // when scrolling DOWN past the button
            if(!entry.isIntersecting) {
                // 1. Measure the current height of the form
                const formHeight = form.offsetHeight;
                // 2. Set the wrapper to that height so the page doesn't collapse
                wrapper.style.minHeight = `${formHeight}px`;
                
                form.classList.add('is-fixed-to-bottom');
            } else {
                form.classList.remove('is-fixed-to-bottom');
                // 3. Reset the wrapper height when the button is back in place
                wrapper.style.minHeight = '0px';
            }
        });
    }, {
        threshold: 0
    });
    
    observer.observe(formThreshold);
});